const ITEMS = [
  "GROUPE HUVIG",
  "ACHAT · VENTE · REVENTE",
  "QUALITÉ CERTIFIÉE",
  "GARANTIE INCLUSE",
  "CHALON-SUR-SAÔNE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#0d0d0d] py-4 select-none">
      <div className="marquee-track items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 pr-10" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
                <span className="font-display font-extrabold text-sm md:text-base uppercase tracking-[0.3em] text-zinc-500">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-[#FF1E27]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
